import dayjs from 'dayjs';

const addMinutes = (date: Date | string, minutes: number): string =>
  dayjs(date).add(minutes, 'minutes').toISOString();

export { addMinutes };
